
const AllServicesGrid = () => {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Construction & Génie Civil',
      description: 'Construction de bâtiments résidentiels, commerciaux, industriels, ainsi que travaux de génie civil, la construction de routes, le montage de maisons préfabriquées et la réalisation de ponts.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: 'ri-stack-line',
      title: 'Matériaux de Construction',
      description: 'Le traitement et la vente de matériaux de construction (moellons, sable, gravier, blocs-ciments, ciment en gros et au détail, briques cuites, tôles, pavés, colonnes, plafonds, chaux, peintures, clous, etc.).',
      color: 'bg-teal-100 text-teal-600'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Carrelage & Revêtements',
      description: 'Les travaux de carrelage (sols, murs, cuisines, salles de bain, espaces extérieurs) avec des finitions professionnelles et durables.',
      color: 'bg-amber-100 text-amber-600'
    },
    {
      icon: 'ri-drop-line',
      title: 'Plomberie Sanitaire',
      description: 'L\'installation et la réparation de systèmes de plomberie sanitaire pour tous types de bâtiments, avec des solutions modernes et efficaces.',
      color: 'bg-cyan-100 text-cyan-600'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Rénovation & Peinture',
      description: 'La rénovation intérieure et extérieure de bâtiments, ainsi que la peinture et les finitions professionnelles pour un résultat impeccable.',
      color: 'bg-rose-100 text-rose-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Électricité Bâtiment',
      description: 'Les travaux d\'électricité bâtiment (installation, maintenance et dépannage) conformes aux normes de sécurité en vigueur.',
      color: 'bg-yellow-100 text-yellow-600'
    },
    {
      icon: 'ri-road-map-line',
      title: 'Aménagement Extérieur',
      description: 'L\'aménagement extérieur (pavage, dallage, clôtures, terrasses) pour embellir et sécuriser vos espaces extérieurs.',
      color: 'bg-emerald-100 text-emerald-600'
    },
    {
      icon: 'ri-grid-line',
      title: 'Faux Plafonds & Cloisons',
      description: 'La réalisation de faux plafonds et cloisons modernes (plâtre, PVC, etc.) pour optimiser l\'espace et l\'acoustique de vos locaux.',
      color: 'bg-lime-100 text-lime-600'
    },
    {
      icon: 'ri-door-line',
      title: 'Menuiserie Aluminium & Bois',
      description: 'La menuiserie en aluminium et en bois (portes, toitures, fenêtres, placards sur mesure) avec des finitions de qualité supérieure.',
      color: 'bg-red-100 text-red-600'
    },
    {
      icon: 'ri-tools-line',
      title: 'Entretien Général',
      description: 'L\'entretien général des bâtiments et espaces commerciaux pour maintenir vos installations en parfait état de fonctionnement.',
      color: 'bg-gray-100 text-gray-600'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Tous Nos <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Une gamme complète de services pour répondre à tous vos besoins en construction et entretien
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${service.color} rounded-xl flex items-center justify-center mb-4 sm:mb-6`}>
                <i className={`${service.icon} text-2xl sm:text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE('/');
              setTimeout(() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 font-medium cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg transform hover:-translate-y-0.5 text-sm sm:text-base"
          >
            Demander un devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
};

export default AllServicesGrid;
